import LockOpenIcon from '@mui/icons-material/LockOpen';
import { Box, Button, Paper, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import logo from '@assets/logo_landing_page.svg';

export const PasswordSaved = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/auth/login');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '3.5rem',
        width: '28rem',
        height: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '1rem',
        }}
      >
        <img
          src={logo}
          style={{
            objectFit: 'cover',
            height: '131px',
            width: '132px',
          }}
          alt='logo'
        />
      </Box>
      <Paper
        elevation={8}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '1.5rem',
          gap: '32px',
          width: '100%',
          borderRadius: 0,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '16px',
            padding: 0,
          }}
        >
          <LockOpenIcon sx={{ fontSize: '3rem' }} color='primary' />
          <Typography
            sx={{ fontWeight: '600', fontSize: '1.5rem', color: 'primary' }}
          >
            Protect your account with MFA
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography
            sx={{
              paddingY: '24px',
              fontSize: '16px',
              lineHeight: '24px',
              fontWeight: '400',
              textAlign: 'center',
            }}
          >
            Your password was saved. Click the button below to continue to sign
            in.
          </Typography>
        </Box>

        <Button
          variant='contained'
          type='submit'
          color='secondary'
          sx={{ color: 'white', padding: '0.5rem', fontWeight: '500' }}
          onClick={handleClick}
          fullWidth
        >
          CONTINUE
        </Button>
      </Paper>
    </Box>
  );
};
